var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0135 109.023L68.1002 39.0429C73.0195 29.2311 87.0248 29.2337 91.9408 39.0472L126.996 109.028C131.436 117.893 124.99 128.332 115.074 128.332H44.9326C35.0144 128.332 28.5682 117.889 33.0135 109.023Z",
    stroke: "#CC7800",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66.666V79.9994",
    stroke: "#CC7800",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105C82.7614 105 85 102.761 85 100C85 97.2386 82.7614 95 80 95C77.2386 95 75 97.2386 75 100C75 102.761 77.2386 105 80 105Z",
    fill: "#CC7800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSymbol);
export default __webpack_public_path__ + "static/media/alertSymbol.06cf59a22d2f9ba0666cb0253833fcd1.svg";
export { ForwardRef as ReactComponent };